export const guide = {
  kicker: 'User guide',
  title: 'How to use the customer portal',
  subtitle:
    'A short walk-through of every page for first-time users. You can change the language at any time from the top of the page.',
  contents: 'On this page',
  backToSignIn: 'Back to sign in',
  openPortal: 'Go to the portal',
  sections: {
    signIn: {
      title: 'Signing in',
      intro: 'The portal is for existing Whatzneu Finance customers. Whatzneu Finance creates your account; there is no self sign-up.',
      steps: [
        'Open the customer login page and enter the email address registered with Whatzneu Finance.',
        'Select "Send code". A 6-digit code arrives in your inbox within a minute or two.',
        'Enter the code and select "Verify and sign in".',
        'This browser stays signed in for up to 60 days. Select "Sign out" when you use a shared computer.',
      ],
    },
    home: {
      title: 'Home',
      intro: 'Your summary page after signing in.',
      steps: [
        'Total outstanding is the balance Whatzneu Finance has recorded across your active debits.',
        'Your active debits lists up to three facilities. Select one to open its details.',
        'Recent payments shows the latest five payments recorded against your account.',
        'Use "Request funds" or "Refer a customer" to start a request.',
      ],
    },
    debits: {
      title: 'Debits',
      intro: 'Every facility on file, including closed ones.',
      steps: [
        'Select a debit to open its full details.',
        'Interest date is the day of each month when interest is due.',
        'Last interest collected is the most recent date Whatzneu Finance recorded an interest payment.',
        'Select "Payments and monthly trend" to see every payment for that debit with a monthly chart.',
      ],
    },
    payments: {
      title: 'Payments',
      intro: 'The full history of payments Whatzneu Finance has recorded.',
      steps: [
        'Each row shows the date, type, amount, status, who received it, and any note.',
        'Use the controls below the table to move between pages or show more rows.',
        'If a payment you made is missing, contact your relationship manager with the date and amount.',
      ],
    },
    deposits: {
      title: 'Deposits',
      intro: 'Deposits recorded with Whatzneu Finance and their maturity dates.',
      steps: [
        'Active deposit balance is the total of your active deposits.',
        'Each row shows the deposit date, amount, maturity date, status, and reference number.',
      ],
    },
    products: {
      title: 'Products',
      intro: 'Published Whatzneu Finance products and services.',
      steps: [
        'Use the category buttons to filter the list.',
        'Select "Register interest" and add an optional message. Whatzneu Finance will contact you.',
        'Some products show "Open product", which opens the provider\'s page in a new tab.',
        'Your interest requests and their status are listed below the products.',
      ],
    },
    requestFunds: {
      title: 'Request funds',
      intro: 'Tell Whatzneu Finance what you need. Every request is reviewed before anything is offered.',
      steps: [
        'Enter the exact amount you need and the minimum amount you can accept.',
        'Enter the monthly interest rate you can manage, between 0.1% and 15%. Whatzneu Finance confirms the final rate.',
        'Describe the purpose in a short sentence and select "Send request".',
        'Track the status and any note from Whatzneu Finance under "Your requests".',
      ],
    },
    referrals: {
      title: 'Refer a customer',
      intro: 'Introduce someone you know who needs funds. The Whatzneu Finance team reviews every referral.',
      steps: [
        'Enter their full name, email, 10-digit mobile number, and the amount they need.',
        'Select "Send referral". Whatzneu Finance contacts them about onboarding.',
        'Follow each referral\'s status and any note from Whatzneu Finance under "Your referrals".',
      ],
    },
    notifications: {
      title: 'Notifications',
      intro: 'Facility updates and payment reminders from Whatzneu Finance.',
      steps: [
        'A gold dot next to "Notifications" in the menu means you have unread messages.',
        'Select an unread notification to mark it as read, or use "Mark all as read".',
      ],
    },
    profile: {
      title: 'Profile',
      intro: 'The details Whatzneu Finance holds for your account.',
      steps: [
        'Check your name, email, mobile number, and address.',
        'To change any detail, contact your relationship manager.',
        'The session card shows until when this browser stays signed in.',
      ],
    },
  },
  statusesTitle: 'What the statuses mean',
  statuses: {
    pending: 'Pending or Submitted: received and waiting for review.',
    inReview: 'In review: the Whatzneu Finance team is looking at it.',
    approved: 'Approved, Active, or Onboarded: accepted and in progress.',
    declined: 'Declined or Rejected: not taken forward. Check the note from Whatzneu Finance.',
    closed: 'Closed: the facility is no longer active.',
  },
  faqTitle: 'Common questions',
  faq: {
    noCode: {
      q: "I didn't receive the code.",
      a: 'Check your spam or promotions folder, wait a minute, then select "Send a new code". Make sure you entered the email registered with Whatzneu Finance.',
    },
    signedOut: {
      q: 'Why was I signed out?',
      a: 'A session ends after 60 days, or earlier if you sign out. Sign in again with a new code.',
    },
    mismatch: {
      q: 'A figure looks wrong.',
      a: 'The portal shows only what Whatzneu Finance has recorded. Contact your relationship manager with the details.',
    },
    security: {
      q: 'How do I keep my account safe?',
      a: 'Never share your sign-in code with anyone, including people who say they are from Whatzneu Finance. Sign out on shared devices.',
    },
  },
  disclaimer: 'Whatzneu Finance is not a bank or an RBI-registered NBFC. Figures in the portal are records Whatzneu Finance holds, not offers.',
};
